<div class="reset-content">
  <hyperkit-typography variant="display" color="primary" align="center"
    >Reset Password</hyperkit-typography
  >
  <hyperkit-typography variant="body2" color="secondary"
  >{{passRequirements}}
</hyperkit-typography>

  <ng-container *ngIf="!formSubmitted">
    <form [formGroup]="form" (ngSubmit)="submitForm()">

      <div class="form-group">
        <hyperkit-input
          class="hyperkit-component"
          type="text"
          id="password"
          label="New Password"
          placeholder="New Password"
          formControlName="password"
          [pattern]="passRegex"
        ></hyperkit-input>
      </div>
      <div class="form-group">
        <hyperkit-input
          class="hyperkit-component"
          type="text"
          label="Confirm Password"
          placeholder="Confirm Password"
          formControlName="confirmPassword"
        ></hyperkit-input>
        <hyperkit-error class="form-error" *ngIf="(form.controls.confirmPassword.touched && form.controls.confirmPassword.dirty) && (form.controls.password.value !== form.controls.confirmPassword.value) && form.controls.confirmPassword.value.length > 0" error="Passwords do not match."></hyperkit-error>
      </div>
      <div class="options">
        <hyperkit-button
        type="submit"
        size="medium"
        routerLink="/"
        [fullWidth]="true"
        color="secondary"
        text="Cancel"
      ></hyperkit-button>
      <hyperkit-button
      type="submit"
      class="sign-in-button"
      size="medium"
      [disabled]="!form.valid"
      [fullWidth]="true"
      color="tertiary"
      text="Change Password"
    ></hyperkit-button>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf="formSubmitted">
    <hyperkit-typography variant="body1" color="primary"
    >Your password has been reset successfully.
  </hyperkit-typography>
    <hyperkit-button
    class="sign-in-button"
    routerLink="/"
    size="medium"
    [fullWidth]="true"
    color="tertiary"
    text="Return to Login"
  ></hyperkit-button>
  </ng-container>
</div>
